import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@alwindows/shared/styles'
import '@alwindows/shared/ui/styles'
import { App } from './App'
import './components/Layout.scss'
import './pages/ScreenHome.scss'
import './pages/PricingCalc.scss'
import './pages/Edit.scss'
import './pages/Summary.scss'
import './pages/Submit.scss'
import './pages/Payment.scss'

const root = document.getElementById('al-screens-root')
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
